import React from 'react';

const Header = () => (
  <div>
    <h1>Les KORDYLEWSKI Ph.D.</h1>
  </div>
);

export default Header;
